import { ActionType, ProColumns } from '@ant-design/pro-components';
import { debounce } from '@mui/material';
import {
  Tooltip as AntdTooltip,
  Button,
  DatePicker,
  Form,
  Input,
  Radio,
  RadioChangeEvent,
} from 'antd';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { AiOutlineDownload } from 'react-icons/ai';
import 'react-resizable/css/styles.css';
import { ListDate, ListStatusProduct } from 'services/commonDate_services';
import { BC08Model, ListKeynValue } from 'services/report_services';
import * as rootStore from 'stores/root_store';
import { commonDatePresenter, commonDateStore, reportPresenter, reportStore } from 'stores/root_store';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import { SearchModel } from './model';
import TemplateReportModal from 'base/ui/components/Modal/TemplateReportModal';
import SearchCollapse from '../reportComponents/searchCollapse';
import Wrapper from 'base/ui/components/Wrapper';
import SaveReportForm from '../reportComponents/reportForm';
import { useResizableColumns } from 'utils/reportHelper';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';


export function workOrderFinished() {
  return observer(() => {

    // loading page when reload
    const [isLoading, setIsLoading] = useState(false);
    //========================================================================================================== //
    //-------------------------------------------      STATE    -------------------------------------------------//
    //========================================================================================================== //
    //-----TÌM KIẾM-------------------------------------------------------------------------------------------- //
    const [dataSearch, setDataSearch] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderByDesc: 'lsx',
        orderBy: '',
      },
      lsx: [],
      tpbtp: '',
      type: 'TH',
      trangThaiMES: ['CLOSED'],
      khachHang: '',
      ngayPhatLenhTu: undefined,
      ngayPhatLenhDen: undefined,
      ngayNhapKhoTu: undefined,
      ngayNhapKhoDen: undefined,
      ngayHoanThanhLSXTu: undefined,
      ngayHoanThanhLSXDen: undefined,
      phanCapSanPham: undefined,
    });

    //lay ngày phát lệnh
    const [pickedDateNPL, setpickedDateNPL] = useState<string>('');
    //lay ngày nhập kho
    const [pickedDateNNK, setpickedDateNNK] = useState<string>('');
    //lay ngày HOÀN thành lsx
    const [pickedDateNHTLSX, setpickedDateNHTLSX] = useState<string>('ThisMonth');
    // Kiểm tra call xong  api lấy ngày picked date
    const [isReady, setIsReady] = useState(false);
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //-----DANH SÁCH (LIST, DATA TABLE)------------------------------------------------------------------------- //
    const [dataTable, setDataTable] = useState<BC08Model[]>([]);
    // autocomplete tp/btp
    const [dropdownProduct, setDropdownProduct] = useState<ListStatusProduct[]>([]);
    // lay danh sach date tu API
    const [commonDate, setCommonDate] = useState<ListDate[]>([]);
    // danh sách LSX
    const [dropdownWO, setDropdownWO] = useState<ListKeynValue[]>([]);
    // list status danh sach trang thai
    const [listStatus, setListStatus] = useState<ListKeynValue[]>([]);
    // phân cấp sản phẩm
    const [listPCSP, setListPCSP] = useState<ListStatusProduct[]>([]);
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //=======================XXX=============ISD REPORT SAMPLE==============XXX================================= //
    // Form item
    const tableRef = useRef<ActionType>();


    // dropdown khách hàng
    const [dropdownCustomer, setDropdownCustomer] = useState<ListStatusProduct[]>([])
    // Lấy danh sách khách hàng
    const getListCustomer = async (keword?: string) => {
      await rootStore.commonDatePresenter.getListCustomer(commonDateStore, keword);
      if (commonDateStore.listStatusProductResponse.isSuccess) {
        setDropdownCustomer(commonDateStore.listStatusProductResponse.data)
      }
    }

    const searchCustomer = useCallback(debounce(getListCustomer, 500), []);




    // Name data save to localstorage
    const constDataName = 'bc-08';
    //========================================================================================================== //
    //---------------------------- - ------HÀM DÙNG CHUNG (GET DATA)------------------- - ----------------------//
    //========================================================================================================== //
    // Lấy danh sách báo cáo lsx hoàn thành

    const getDataTable = async (searchValue: SearchModel) => {
      await reportPresenter.getDataBC08(reportStore, {
        ...searchValue,
      });
      if (reportStore.BC08NewResponse.isSuccess) {
        const data = reportStore.BC08NewResponse.data.map((item) => ({
          ...item,
          key: `${item.stt}`,
          children: item.chiTietBaoCao.map((chiTietBaoCao, index) => {
            return { ...chiTietBaoCao, key: `${item.stt}.${index + 1}` };
          }),
        }));
        setDataTable(data);
        return data;
      }
      return [];
    };
    // hàm lấy anh sách date
    const getDateCommon = async () => {
      await rootStore.commonDatePresenter.getListCommonDate(rootStore.commonDateStore);
      if (rootStore.commonDateStore.listDate.isSuccess) {
        setCommonDate(rootStore.commonDateStore.listDate.data);
      }
    };

    // Lấy dropdown products
    const getDropdownProduct = async (keyword = '') => {
      if (keyword && keyword.length >= 3) {
        await commonDatePresenter.getListDropdownProduct(commonDateStore, keyword, 'BC');
        setDropdownProduct(commonDateStore.listDropdownProduct);
      } else {
        setDropdownProduct([]);
      }
    };
    const debounceProduct = useCallback(debounce(getDropdownProduct, 300), []);

    // Lấy dropdown lệnh sản xuất
    const getDropdownLSX = async (keyword = '') => {
      if (keyword && keyword.length >= 3) {
        await reportPresenter.getDropdownWo(reportStore, keyword);
        if (reportStore.listKeynValue.isSuccess) {
          setDropdownWO(reportStore.listKeynValue.data);
        }
      } else {
        setDropdownWO([]);
      }
    };
    // debounce lsx
    const debounceLSX = useCallback(debounce(getDropdownLSX, 300), []);

    const getListStatus = async () => {
      await rootStore.commonDatePresenter.getDropdownByKeyword(rootStore.commonDateStore, 'WorkOrderStatusMes');
      let array: ListKeynValue[] = [];
      rootStore.commonDateStore.dropdownByKey.map((it) => {
        if (it.key !== 'PLANNED') array.push(it);
      });
      setListStatus(array);
    };

    // Lấy danh sách phân cấp sản phẩm
    const getDSPhanCapSP = async (kw?: string) => {
      const list = await commonDatePresenter.getListPhanCapSP(kw)
      setListPCSP(list);
    }
    const debouncePCSP = useCallback(debounce(getDSPhanCapSP, 300), []);


    // lấy ngày từ commonDate
    const getDateByKey = async (key: string, type: 'phatlenh' | 'nhapkho' | 'hoanThanh') => {
      await rootStore.commonDatePresenter.getDataByCommonDate(rootStore.commonDateStore, key);
      if (rootStore.commonDateStore.commonDate) {
        switch (type) {
          case 'nhapkho': {
            setDataSearch({
              ...dataSearch,
              ngayNhapKhoTu:
                rootStore.commonDateStore.commonDate.fromDate !== ''
                  ? rootStore.commonDateStore.commonDate.fromDate
                  : undefined,
              ngayNhapKhoDen:
                rootStore.commonDateStore.commonDate.toDate !== ''
                  ? rootStore.commonDateStore.commonDate.toDate
                  : undefined,
            });
            break;
          }
          case 'phatlenh': {
            setDataSearch({
              ...dataSearch,
              ngayPhatLenhTu:
                rootStore.commonDateStore.commonDate.fromDate !== ''
                  ? rootStore.commonDateStore.commonDate.fromDate
                  : undefined,
              ngayPhatLenhDen:
                rootStore.commonDateStore.commonDate.toDate !== ''
                  ? rootStore.commonDateStore.commonDate.toDate
                  : undefined,
            });
            break;
          }
          case 'hoanThanh': {
            setDataSearch({
              ...dataSearch,
              ngayHoanThanhLSXTu:
                rootStore.commonDateStore.commonDate.fromDate !== ''
                  ? rootStore.commonDateStore.commonDate.fromDate
                  : undefined,
              ngayHoanThanhLSXDen:
                rootStore.commonDateStore.commonDate.toDate !== ''
                  ? rootStore.commonDateStore.commonDate.toDate
                  : undefined,
            });
            break;
          }
        }
      }
    };
    //=======================XXX========================XXX=========================XXX========================= //

    //========================================================================================================== //
    //-------------------------------------------LOAD DATA-------------------------------------------------//
    //========================================================================================================== //

    // KHỞI TẠO
    useEffect(() => {
      const doInit = async () => {
        setIsLoading(true);
        await getDateCommon();
        await getDateByKey(pickedDateNHTLSX, 'hoanThanh');
        getListCustomer();
        setIsReady(true);
        // await getDropdownProduct();
        // await getDropdownLSX();
        await getListStatus();
        getDSPhanCapSP()
        setIsLoading(false);
      };
      doInit();
    }, []);
    //=======================XXX========================XXX=========================XXX========================= //

    //========================================================================================================== //
    //-------------------------------------------COMMON HANDLE-------------------------------------------------//
    //========================================================================================================== //
    //-----COMMON DATE-------------------------------------------------------------------------------------------- //
    const handleGetCommonDate = async (value: any, option: ListKeynValue | ListKeynValue[], type: string) => {
      if (type === 'createTimeWO') {
        if (option && !Array.isArray(option)) {
          setpickedDateNPL(option.key);
          await getDateByKey(option.key, 'phatlenh');
        } else {
          setpickedDateNPL('');
          setDataSearch({ ...dataSearch, ngayPhatLenhTu: undefined, ngayPhatLenhDen: undefined });
        }
      } else if (type === 'receiveTime') {
        if (option && !Array.isArray(option)) {
          setpickedDateNNK(option.key);
          await getDateByKey(option.key, 'nhapkho');
        } else {
          setpickedDateNNK('');
          setDataSearch({ ...dataSearch, ngayNhapKhoTu: undefined, ngayNhapKhoDen: undefined });
        }
      } else if (type === 'ngayHoanThanhLSXDen') {
        if (option && !Array.isArray(option)) {
          setpickedDateNHTLSX(option.key);
          await getDateByKey(option.key, 'hoanThanh');
        } else {
          setpickedDateNHTLSX('');
          setDataSearch({ ...dataSearch, ngayHoanThanhLSXTu: undefined, ngayHoanThanhLSXDen: undefined });
        }
      }
    };

    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //-----COMMON STATUS-------------------------------------------------------------------------------------------- ////  FOR SEARCH : CẬP NHẬT THAY ĐỔI TRẠNG THÁI
    // const handleChangeStatus = async (e: React.SyntheticEvent<Element, Event>, value: ListKeynValue | null) => {
    //   if (value) {
    //     setDataSearch({ ...dataSearch, trangThaiMES: value.key });
    //   } else {
    //     setDataSearch({ ...dataSearch, trangThaiMES: '' });
    //   }
    // };
    const handleChangeSelectMul = (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && Array.isArray(option)) {
        setDataSearch({
          ...dataSearch,
          [idKey]: option.map((val) => {
            return val.key;
          }),
        });
      } else {
        setDataSearch({
          ...dataSearch,
          [idKey]: [],
        });
      }
    };


    //=======================XXX========================XXX=========================XXX========================= //

    //========================================================================================================== //
    //-------------------------------------------TÌM KIẾM-------------------------------------------------//
    //========================================================================================================== //
    // Tìm kiếm


    const handleSearch = async () => {
      setIsLoading(true);
      setDataSearch({ ...dataSearch, paging: { ...dataSearch.paging, pageIndex: 1 } });
      await getDataTable({ ...dataSearch, paging: { ...dataSearch.paging, pageIndex: 1 } });
      setIsLoading(false);
      const temp = cloneDeep(columns);
      if (dataSearch.type === 'TH') {
        temp.map((ct) => {
          if (ct.hideInTable === false) {
            ct.hideInTable = true;
            ct.hideInSetting = true;
            return ct;
          }
          return ct;
        });

        setColumn(temp);
      } else if (dataSearch.type === 'CT') {

        temp.map((ct) => {
          if (ct.hideInTable === true) {
            ct.hideInTable = false;
            ct.hideInSetting = false;
            return ct;
          }
          return ct;
        });
        setColumn(temp);

      }
    };
    //=======================XXX========================XXX=========================XXX========================= //
    const defaultColumn: ProColumns<BC08Model>[] = [
      {
        title: 'STT',
        dataIndex: 'stt',
        width: 75,
        key: 'stt',
        fixed: 'left',
        className: '!rounded-none !py-1',
      },
      // Loại LSX
      {
        title: 'Loại LSX',
        dataIndex: 'loaiLSX',
        key: 'loaiLSX',
        className: '!py-1',
        fixed: 'left',
        width: 100,
        sorter: true,
      },
      // Lệnh SX
      {
        title: 'Lệnh SX',
        dataIndex: 'lsx',
        key: 'lsx',
        width: 120,
        className: '!py-1',
        fixed: 'left',
        sorter: true,
      },
      // LSX tổng hợp
      {
        title: 'LSX tổng hợp',
        dataIndex: 'lsxTongHop',
        key: 'lsxTongHop',
        width: 120,
        className: '!py-1',
        // fixed: 'left',
        sorter: true,
      },
      // trạng thái lệnh
      {
        title: 'Trạng thái lệnh',
        dataIndex: 'trangThaiLSX',
        key: 'trangThaiLSX',
        width: 130,
        className: '!py-1',
        // fixed: 'left',
      },
      // Hạng mục in
      {
        title: 'Hạng mục in',
        dataIndex: 'hangMucIn',
        key: 'hangMucIn',
        width: 130,
        className: '!py-1',
        // fixed: 'left',
      },
      // Ghi chú LSX
      {
        title: 'Ghi chú LSX',
        dataIndex: 'ghiChuLSX',
        key: 'ghiChuLSX',
        className: '!py-1',
        fixed: 'left',
        sorter: true,
        width: 300,
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Ngày phát lệnh
      {
        title: 'Ngày ban hành LSX',
        dataIndex: 'ngayPhatLenh',
        key: 'ngayPhatLenh',
        width: 150,
        sorter: true,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'center',
              },
            },
            children: record.ngayPhatLenh ? moment(record.ngayPhatLenh).format('DD/MM/YYYY HH:mm:ss') : '',
          };
        },
      },
      // Ngày hàng in về xưởng
      {
        title: 'Ngày hàng in về xưởng',
        dataIndex: 'ngayHangInVeXuong',
        key: 'ngayHangInVeXuong',
        width: 150,
        className: 'text-ellipsis overflow-hidden !py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'center',
              },
            },
            children: record.ngayHangInVeXuong ? (
              <div className="!whitespace-nowrap text-center">
                {moment(record.ngayHangInVeXuong).format('DD/MM/YYYY HH:mm:ss')}
              </div>
            ) : (
              ''
            ),
          };
        },
      },
      // Ngày yêu cầu nhập kho
      {
        title: 'Ngày yêu cầu nhập kho',
        dataIndex: 'ngayGiaoHang',
        key: 'ngayGiaoHang',
        width: 150,
        sorter: true,
        className: '!!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'center',
              },
            },
            children: record.ngayGiaoHang ? moment(record.ngayGiaoHang).format('DD/MM/YYYY') : '',
          };
        },
      },
      // Thời gian thực tế hoàn thành lệnh
      {
        title: 'TG thực tế HT lệnh',
        dataIndex: 'tgThucTeHoanThanhLenh',
        key: 'tgThucTeHoanThanhLenh',
        width: 200,
        sorter: true,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'center',
              },
            },
            children: record.tgThucTeHoanThanhLenh
              ? moment(record.tgThucTeHoanThanhLenh).format('DD/MM/YYYY HH:mm:ss')
              : '',
          };
        },
      },
      // Khách hàng
      {
        title: 'Khách hàng',
        dataIndex: 'khachHang',
        key: 'khachHang',
        width: 200,
        sorter: true,
        className: '!py-1',
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Kiểu in
      {
        title: 'Kiểu in',
        dataIndex: 'kieuIn',
        key: 'kieuIn',
        width: 150,
        sorter: true,
        className: '!py-1',
      },
      // Loại FSC
      {
        title: 'Loại FSC',
        dataIndex: 'loaiFSC',
        key: 'loaiFSC',
        width: 100,
        sorter: true,
        className: '!py-1',
      },
      // Phân cấp sản phẩm
      {
        title: 'Phân cấp SP',
        dataIndex: 'phanCapSP',
        key: 'phanCapSP',
        width: 150,
        sorter: true,
        className: '!py-1',
      },
      // Nhóm sản phẩm
      {
        title: 'Nhóm sản phẩm',
        dataIndex: 'nhomSP',
        key: 'nhomSP',
        width: 150,
        className: '!py-1',
      },
      // Nhóm SP kinh doanh
      {
        title: 'Nhóm SP kinh doanh',
        dataIndex: 'nhomSPChiTiet',
        key: 'nhomSPChiTiet',
        width: 150,
        className: '!py-1',
      },
      //Nhóm SP sản xuất
      {
        title: 'Nhóm SP sản xuất',
        dataIndex: 'nhomSPSX',
        key: 'nhomSPSX',
        width: 150,
        className: '!py-1',
      },
      // Mã SP
      {
        title: 'Mã SP',
        dataIndex: 'maSP',
        key: 'maSP',
        width: 150,
        sorter: true,
        className: '!py-1',
      },
      // Tên Sản phẩm
      {
        title: 'Tên SP',
        dataIndex: 'tenSP',
        key: 'tenSP',
        width: 200,
        className: '!py-1',
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Kích thước sản phẩm (mm)
      {
        title: 'Kích thước SP (mm)',
        dataIndex: 'kichThuocSP',
        key: 'kichThuocSP',
        width: 180,
        sorter: true,
        className: '!py-1',
      },
      // Khổ trải (mm)
      {
        title: 'Khổ trải (mm)',
        dataIndex: 'khoTrai',
        key: 'khoTrai',
        width: 150,
        sorter: true,
        className: '!py-1',
      },
      // Số lượng phát lệnh
      {
        title: 'SL phát lệnh',
        dataIndex: 'slPhatLenh',
        key: 'slPhatLenh',
        width: 100,
        sorter: true,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: text !== null && text !== '-' ? formatNumber(Number(text), 0) : '-',
          };
        },
      },
      // Số lượng hàng in về xưởng
      {
        title: 'SL hàng in về xưởng',
        dataIndex: 'slHangInVeXuong',
        key: 'slHangInVeXuong',
        width: 100,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: text !== null && text !== '-' ? formatNumber(Number(text), 1) : '-',
          };
        },
      },
      // số lượng hàng lỗi ở các CĐSX
      {
        title: 'SL hàng lỗi ở các CĐSX',
        dataIndex: 'slHangLoiCacCDSX',
        key: 'slHangLoiCacCDSX',
        width: 100,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: text !== null && text !== '-' ? formatNumber(Number(text), 1) : '-',
          };
        },
      },
      // Số lượng thành phẩm nhập kho
      {
        title: 'SL thành phẩm nhập kho',
        dataIndex: 'sltpNhapKho',
        key: 'sltpNhapKho',
        width: 150,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: formatNumber(Number(text), 1),
          };
        },
      },
      // ĐVT
      {
        title: 'ĐVT',
        width: 75,
        className: '!py-1',
        dataIndex: 'dvt',
        key: 'dvt',
        sorter: true,
      },
      // Công đoạn nhập kho
      {
        title: 'Công đoạn nhập kho',
        width: 150,
        className: ' !py-1',
        dataIndex: 'congDoanNK',
        key: 'congDoanNK',
      },
      // Ngày hoàn thành nhập kho (Ngày chứng từ)
      {
        title: 'Ngày hoàn thành nhập kho (Ngày chứng từ)',
        dataIndex: 'ngayNhapKho',
        key: 'ngayNhapKho',
        width: 200,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'center',
              },
            },
            children: record.ngayNhapKho ? moment(record.ngayNhapKho).format('DD/MM/YYYY HH:mm') : '',
          };
        },
      },
      // Thời gian nhập kho thực tế
      {
        title: 'TG nhập kho thực tế',
        dataIndex: 'tgThucTeNK',
        key: 'tgThucTeNK',
        width: 200,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'center',
              },
            },
            children: record.tgThucTeNK ? moment(record.tgThucTeNK).format('DD/MM/YYYY HH:mm') : '',
          };
        },
      },
      // Tổng số lần nhập kho
      {
        title: 'Tổng số lần nhập kho',
        dataIndex: 'tongSoLanNK',
        key: 'tongSoLanNK',
        width: 150,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: formatNumber(Number(text), 0),
          };
        },
      },
      // ===============================================================================================================================================
      // CHI TIẾT
      {
        title: 'Số phiếu nhập kho (MES)',
        dataIndex: 'soPhieuNhapKhoMES',
        key: 'soPhieuNhapKhoMES',
        width: 150,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'left',
              },
            },
            children: text,
          };
        },
      },
      // WorkOrder Completion (Chi tiết)
      {
        title: 'WorkOrder Completion',
        dataIndex: 'workOrderCompletion',
        key: 'workOrderCompletion',
        width: 200,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
      },
      // ===============================================xx==================================xx=============================================

      // Số Iot
      {
        title: 'Số LOT',
        dataIndex: 'soLOT',
        key: 'soLOT',
        width: 150,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {},
            },
            children: text,
          };
        },
      },
      // Tình trạng TP/BTP nhập kho (Chi tiết)
      {
        title: 'Tình trạng TP/BTP nhập kho',
        dataIndex: 'tinhTrangTPBTPNhapKHo',
        key: 'tinhTrangTPBTPNhapKHo',
        width: 200,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
      },
      // Người nhập kho (Chi tiết)
      {
        title: 'Người nhập kho',
        dataIndex: 'nguoiNhapKho',
        key: 'nguoiNhapKho',
        width: 200,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
      },
      // Ghi chú nhập kho (Chi tiết)
      {
        title: 'Ghi chú nhập kho',
        dataIndex: 'ghiChuNhapKho',
        key: 'ghiChuNhapKho',
        width: 400,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
      },

      // Thừa/thiếu so với số lượng LSX đã ra
      {
        title: 'Thừa/thiếu so với số lượng LSX đã ra',
        dataIndex: 'thuaThieuSoVoiLSX',
        key: 'thuaThieuSoVoiLSX',
        width: 200,
        className: '!py-1',
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: text !== null && text !== '-' ? formatNumber(Number(text), 1) : '-',
          };
        },
      },
      // Tỷ lệ lỗi
      {
        title: 'Tỷ lệ lỗi',
        dataIndex: 'tyLeLoi',
        key: 'tyLeLoi',
        width: 100,
        className: '!py-1',

        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: text !== null && text !== '-' ? formatNumber(Number(text), 2) + '%' : '-',
          };
        },
      },


      // ===========================================================================================================================================
      // ----------------------------------CHI TIẾT
      // thứ tự công đoạn
      {
        title: 'Thứ tự công đoạn',
        dataIndex: 'thuTuCongDoan',
        key: 'thuTuCongDoan',
        width: 150,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: text !== null && text !== '-' ? text : '-',
          };
        },
      },
      // công đoạn
      {
        title: 'Công đoạn',
        dataIndex: 'congDoan',
        key: 'congDoan',
        width: 150,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
      },
      // Tick hoàn thành công đoạn
      {
        title: 'Tick hoàn thành công đoạn',
        dataIndex: 'tickHoanThanhCongDoanNhapKho',
        key: 'tickHoanThanhCongDoanNhapKho',
        width: 170,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
        onCell: () => ({
          className: "text-center",
        })
      },
      // SL ghi nhận (pcs)
      {
        title: 'SL ghi nhận (pcs)',
        dataIndex: 'slGhiNhanPCS',
        key: 'slGhiNhanPCS',
        width: 150,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: text !== null && text !== '-' ? formatNumber(Number(text), 1) : '-',
          };
        },
      },
      // SL Đạt
      {
        title: 'SL Đạt',
        dataIndex: 'slDat',
        key: 'slDat',
        width: 100,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
        render: (text) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: text !== null && text !== '-' ? formatNumber(Number(text), 1) : '-',
          };
        },
      },
      // SL Lỗi
      {
        title: 'SL Lỗi',
        dataIndex: 'slLoi',
        key: 'slLoi',
        width: 100,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
        render: (text) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: text !== null && text !== '-' ? formatNumber(Number(text), 1) : '-',
          };
        },
      },
      // Đơn vị tính đvt
      {
        title: 'ĐVT',
        dataIndex: 'dvT2',
        key: 'dvT2',
        width: 100,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
      },
      // Tỷ lệ lỗi theo công đoạn
      {
        title: 'Tỷ lệ lỗi theo công đoạn',
        dataIndex: 'tyLeLoiTheoCongDoan',
        key: 'tyLeLoiTheoCongDoan',
        width: 150,
        className: 'text-ellipsis overflow-hidden !py-1',
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {
                textAlign: 'right',
              },
            },
            children: text !== '-' ? formatNumber(Number(text), 2) + '%' : '-',
          };
        },
      },
      // Tổng TG sản xuât của công đoạn
      {
        title: 'Thời gian sản xuất thực tế\n(Đã nhân tỷ lệ ghép bài) ',
        className: '!py-1 whitespace-pre-line',
        hideInTable: true,
        hideInSetting: true,
        children: [
          {
            title: 'Giờ',
            dataIndex: 'soGioTongTGSanXuat',
            key: 'soGioTongTGSanXuat',
            width: 120,
            className: '!py-1',
            render: (text, record) => {
              return {
                props: {
                  style: {
                    textAlign: 'right',
                  },
                },
                children: text !== '-' ? formatNumber(Number(text), 0) : '-',
              };
            },
          },
          {
            title: 'Phút',
            dataIndex: 'soPhutTongTGSanXuat',
            key: 'soPhutTongTGSanXuat',
            width: 120,
            className: '!py-1',
            render: (text, record) => {
              return {
                props: {
                  style: { textAlign: 'right' },
                },
                children: text !== null && text !== '-' ? formatNumber(Number(text), 0) : '-',
              };
            },
          },
        ],
      },
      // Ghi chú ghi nhận từng công đoạn
      {
        title: 'Ghi chú ghi nhận từng công đoạn',
        dataIndex: 'ghiChuGhiNhan',
        key: 'ghiChuGhiNhan',
        width: 200,
        className: '!py-1',
        hideInTable: true,
        hideInSetting: true,
        render: (text, record) => {
          return {
            props: {
              style: {},
            },
            children: text && text !== '-' ? <AntdTooltip title={text}>{text}</AntdTooltip> : '-',
          };
        },
      },
    ];

    // List document dropdown

    // Custom default columns table with resizeable
    const [columns, setColumn] = useState<ProColumns<BC08Model>[]>(defaultColumn);



    const {
      isResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      setIsResizablePresent,
      handleResize,
    } = useResizableColumns<BC08Model>(columns, setColumn, constDataName);

    return (
      <div className="w-full  py-3 px-5">
        <SearchCollapse title="BC08. BÁO CÁO LỆNH SẢN XUẤT ĐÃ HOÀN THÀNH">
          <form className="w-full px-8  py-2 lg:grid lg:grid-cols-2 flex flex-col gap-y-2">
            {/* Lệnh sản xuất */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Lệnh sản xuất"
                placeholder="Chọn lệnh sản xuất"
                data={dropdownWO}
                onChangeValue={handleChangeSelectMul}
                idKey="lsx"
                showSearch
                allowClear
                onDeselect={() => setDropdownWO([])}
                onClear={() => setDropdownWO([])}
                onSearch={async (value) => await debounceLSX(value)}
              />
            </div>
            {/* Sản phẩm */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <CustomSelect
                title="TP/BTP"
                data={dropdownProduct}
                onChangeValue={(value, option, idKey) => {
                  if (option && !Array.isArray(option)) {
                    setDataSearch({ ...dataSearch, tpbtp: option.key });
                  } else {
                    setDataSearch({ ...dataSearch, tpbtp: '' });
                  }
                }}
                idKey="tpbtp"
                showSearch
                allowClear
                placeholder="Chọn TP/BTP"
                onClear={() => setDropdownProduct([])}
                onDeselect={() => setDropdownProduct([])}
                onSearch={async (value) => await debounceProduct(value)}
              />
            </div>

            {/* Chọn trạng thái */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Trạng thái LSX MES"
                data={listStatus}
                defaultValue={{ key: 'CLOSED', value: 'Đóng lệnh' }}
                onChangeValue={handleChangeSelectMul}
                idKey="trangThaiMES"
                placeholder="--Tất cả--"
              />
            </div>
            {/* Khách hàng */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Khách hàng"
                placeholder="Chọn khách hàng"
                data={dropdownCustomer}
                onChangeValue={(value) => {
                  setDataSearch({
                    ...dataSearch,
                    khachHang: value
                  });
                }}
                idKey="khachHang"
                showSearch
                allowClear
                onDeselect={() => setDropdownCustomer([])}
                onClear={() => setDropdownCustomer([])}
                onSearch={async (value) => await searchCustomer(value)}
              />
            </div>
            {/* Phân cấp sản phẩm */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Phân cấp sản phẩm"
                data={listPCSP}
                allowClear
                showSearch
                filterOption={false}
                onChangeValue={(value, option, idKey) => {
                  if (option) {
                    setDataSearch({ ...dataSearch, phanCapSanPham: option.key });
                  } else {
                    setDataSearch({ ...dataSearch, phanCapSanPham: undefined });
                  }
                }}
                onSearch={(value) => debouncePCSP(value)}
                idKey="phanCapSanPham"
                placeholder="Chọn phân cấp sản phẩm"
              />
            </div>
            {/* Chọn Ngày pháy lệnh */}
            <div className="w-full sm:items-center grid grid-cols-3 col-start-1">
              <CustomSelect
                title="Ngày ban hành LSX"
                data={commonDate}
                onChangeValue={(value, option, idKey) => handleGetCommonDate(value, option, 'createTimeWO')}
                idKey="createTimeWO"
                showSearch
                allowClear
                placeholder="Chọn khoảng thời gian"
              />
            </div>
            <div></div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label htmlFor="ngayPhatLenhTu" className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Từ ngày
              </label>

              <DatePicker
                id="ngayPhatLenhTu"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDateNPL !== 'Custom' && pickedDateNPL !== ''}
                value={dataSearch.ngayPhatLenhTu ? dayjs(dataSearch.ngayPhatLenhTu) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, ngayPhatLenhTu: pickDate });
                }}
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label htmlFor="ngayPhatLenhDen" className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Đến ngày
              </label>

              <DatePicker
                id="ngayPhatLenhDen"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDateNPL !== 'Custom' && pickedDateNPL !== ''}
                value={dataSearch.ngayPhatLenhDen ? dayjs(dataSearch.ngayPhatLenhDen) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, ngayPhatLenhDen: pickDate });
                }}
              />
            </div>

            {/* Chọn thời gian ngày nhập kho */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Ngày nhập kho"
                data={commonDate}
                onChangeValue={(value, option, idKey) => handleGetCommonDate(value, option, 'receiveTime')}
                idKey="receiveTime"
                showSearch
                allowClear
                placeholder="Chọn khoảng thời gian"
              />
            </div>
            <div></div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label htmlFor="ngayNhapKhoTu" className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Từ ngày
              </label>

              <DatePicker
                id="ngayNhapKhoTu"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDateNNK !== 'Custom' && pickedDateNNK !== ''}
                value={dataSearch.ngayNhapKhoTu ? dayjs(dataSearch.ngayNhapKhoTu) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, ngayNhapKhoTu: pickDate });
                }}
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label htmlFor="ngayNhapKhoDen" className="min-w-[150px] font-bold text-default text-black sm:text-end">
                Đến ngày
              </label>

              <DatePicker
                id="ngayNhapKhoDen"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDateNNK !== 'Custom' && pickedDateNNK !== ''}
                value={dataSearch.ngayNhapKhoDen ? dayjs(dataSearch.ngayNhapKhoDen) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, ngayNhapKhoDen: pickDate });
                }}
              />
            </div>

            {/* Thời gian hoàn thành lệnh */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Thời gian hoàn thành lệnh"
                data={commonDate}
                value={commonDate.find((date) => date.key === pickedDateNHTLSX)}
                onChangeValue={(value, option, idKey) => handleGetCommonDate(value, option, 'ngayHoanThanhLSXDen')}
                idKey="ngayHoanThanhLSXDen"
                showSearch
                allowClear
                placeholder="Chọn khoảng thời gian"
              />
            </div>
            <div></div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label
                htmlFor="ngayHoanThanhLSXTu"
                className="min-w-[150px] font-bold text-default text-black sm:text-end"
              >
                Từ ngày
              </label>

              <DatePicker
                id="ngayHoanThanhLSXTu"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDateNNK !== 'Custom' && pickedDateNNK !== ''}
                value={dataSearch.ngayHoanThanhLSXTu ? dayjs(dataSearch.ngayHoanThanhLSXTu) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, ngayHoanThanhLSXTu: pickDate });
                }}
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label
                htmlFor="ngayHoanThanhLSXDen"
                className="min-w-[150px] font-bold text-default text-black sm:text-end"
              >
                Đến ngày
              </label>

              <DatePicker
                id="ngayHoanThanhLSXDen"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDateNNK !== 'Custom' && pickedDateNNK !== ''}
                value={dataSearch.ngayHoanThanhLSXDen ? dayjs(dataSearch.ngayHoanThanhLSXDen) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, ngayHoanThanhLSXDen: pickDate });
                }}
              />
            </div>

            {/* xem theo */}
            <div className="w-full sm:flex-row sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">Xem theo</label>
              <div className="col-span-2 sm:ml-5 text-default flex gap-x-4 gap-y-2 flex-wrap">
                <Radio.Group
                  onChange={(e: RadioChangeEvent) => {
                    setDataSearch({ ...dataSearch, type: e.target.value });
                  }}
                  value={dataSearch.type}
                >
                  <Radio className="!text-default" value={'TH'}>
                    Tổng hợp
                  </Radio>
                  <Radio className="!text-default" value={'CT'}>
                    Chi tiết công đoạn
                  </Radio>
                </Radio.Group>
              </div>
            </div>

            {/* button tìm kiếm */}
            <div className="w-full flex justify-center col-span-2 mt-2">
              <Button
                type="primary"
                loading={isLoading}
                onClick={handleSearch}
                className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
              >
                Chạy báo cáo
              </Button>
            </div>
          </form>
        </SearchCollapse>

        {/* table main */}
        <Wrapper>
          {isReady ? (
            <CustomProTable<BC08Model>
              columns={columns}
              handleResize={handleResize}
              isResizablePresent={isResizablePresent}
              resizableColumnSelect={resizableColumnSelect}
              className={'[&_.ant-table-row-level-0>td]:!bg-[#ADE498]'}
              loading={isLoading}
              request={async (params = {}, sort, filter) => {
                setIsLoading(true);
                const data = await getDataTable({
                  ...dataSearch,
                  paging: {
                    ...dataSearch.paging,
                    orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                    orderByDesc: Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                  },
                });
                if (Object.values(sort).length) {
                  setDataSearch({
                    ...dataSearch,
                    paging: {
                      ...dataSearch.paging,
                      orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                      orderByDesc:
                        Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                    },
                  });
                }
                setIsLoading(false);
                return {
                  data: data,
                  success: rootStore.reportStore.BC08Response.isSuccess,
                };
              }}


              headerTitle={<>
                {/* bảng chú thích */}
                <table
                  width={300}
                  className="h-fit bg-white text-default table-auto space-collapse"
                >
                  <thead className="text-white !bg-[#1677ff]">
                    <tr>
                      <th
                        className="font-semibold border border-border_input py-1"
                      >
                        Màu sắc
                      </th>
                      <th
                        className="font-semibold border border-border_input"
                      >
                        Diễn giải
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        className={`px-2 border border-border_input bg-[#ade498]`}
                        width={100}
                      >
                      </td>
                      <td
                        className={"border border-border_input px-2 py-1"}
                      >
                        {`Phân biệt WO`}
                      </td>
                    </tr>
                    <tr>
                      <td
                        className={`px-2 border border-border_input bg-[#fff]`}
                        width={100}
                      >
                      </td>
                      <td
                        className={"border border-border_input px-2 py-1"}
                      >
                        {`Phân biệt CĐSX`}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>}

              dataSource={dataTable.map((data) => data)}
              actionRef={tableRef} // Gán biến tham chiếu cho instance của bảng
              columnsState={{
                value: Object.keys(columnsState).length > 0 ? columnsState : undefined,
                onChange: (newColumnsState) => {
                  handleColumnsStateChange(newColumnsState);
                },
              }}
              search={false}
              expandable={{
                expandedRowKeys: [...dataTable.map((i) => i.stt + '')],
                expandIcon: () => {
                  return <></>;
                },
              }}
              pagination={{
                pageSize: dataSearch.paging.pageSize,
                total: rootStore.reportStore.BC08NewResponse.paging?.totalCount,
                current: dataSearch.paging.pageIndex,
                responsive: true,
                pageSizeOptions: [10, 25, 50, 100],
                showSizeChanger: true,
                position: ['topRight', 'bottomRight'],
                style: { margin: '10px 0' },
                showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} mục`,
                onChange: (page, pageSize) => {
                  setDataSearch({
                    ...dataSearch,
                    paging: { ...dataSearch.paging, pageIndex: page, pageSize: pageSize },
                  });
                },
              }}
              dateFormatter="string"
              toolBarRender={() => [
                <Button
                  size="middle"
                  loading={isLoading}
                  className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                  onClick={async () => {
                    setIsLoading(true);
                    await rootStore.reportPresenter.exportExcelBC08({ ...dataSearch });
                    setIsLoading(false);
                  }}
                  type="primary"
                >
                  <AiOutlineDownload className="block text-base" />
                  <span className="block">Export Excel</span>
                </Button>,
                <SaveReportForm
                  templateReportModalRef={templateReportModalRef}
                  userReports={userReports}
                  selectedReportId={selectedReportId}
                  setIsResizablePresent={setIsResizablePresent}
                />,
              ]}
            />
          ) : (
            <CustomProTable<BC08Model> columns={columns} handleResize={handleResize} />
          )}
        </Wrapper>
        <TemplateReportModal ref={templateReportModalRef} {...templateReportModalProps} />
      </div>
    );
  });
}
